import {IStateService} from 'angular-ui-router';
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import {TSDocumentType} from '../../../models/enums/TSDokumentType';
import TSFremdkosten from '../../../models/TSFremdkosten';
import TSFremdkostenDaten from '../../../models/TSFremdkostenDaten';
import DVBernUtil from '../../../utils/DVBernUtil';
import {IFremdkostenStateParams} from '../../gesuch.route';
import AbstractModelManagerController from '../abstractModelManagerController';
import {TSLeistungsart} from '../../../models/enums/TSLeistungsart';
import {TSSchadenfallStatus} from '../../../models/enums/TSSchadenfallStatus';

declare let require: any;
declare let angular: any;

import IComponentOptions = angular.IComponentOptions;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

let styles = require('./fremdkostenView.scss');
let template = require('./fremdkostenView.html');

export class FremdkostenEditViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = FremdkostenViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        fremdkosten: '<',
        schadenfallId: '<',
        schaetzung: '<',
    };
}

export class FremdkostenViewController extends AbstractModelManagerController<TSFremdkosten> {

    fremdkosten: TSFremdkosten;
    form: IFormController;
    schadenfallId: string;
    doctype: TSDocumentType = TSDocumentType.FREMDKOSTEN_DOC;
    schaetzung: boolean;

    static $inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state'];

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil, schadenfallModelManager: SchadenfallModelManager,
                private $q: IQService,
                $scope: IScope, private $translate: ITranslateService, private $log: ILogService,
                private $state: IStateService, private $stateParams: IFremdkostenStateParams,
    ) {
        super(schadenfallModelManager, $scope, $state.current.name);

    }

    $onInit() {

        super.$onInit();
        if (!this.fremdkosten) {
            this.fremdkosten = new TSFremdkosten();
            this.fremdkosten.schaetzung = this.schaetzung;
            this.fremdkosten.fremdkostenDatenFS = new TSFremdkostenDaten();
            this.$log.warn('initialized fremdkosten to edit directly in view, should pass fremdkosten to edit along');
        } else {
            this.initialModel = this.fremdkosten;
            this.model = angular.copy(this.fremdkosten);
        }

    }

    public saveFremdkosten() {
        if (this.isModelValid() && this.fremdkosten) {
            this.schadenfallModelManager.saveFremdkosten(this.getModel()).then((result) => {
                this.navigateAway();
            });
        } else {
            this.$log.debug('Form was not valid');
        }
    }

    public cancelFremdkosten() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.navigateAway();
    }

    private navigateAway() {
        const nextPage = this.schaetzung ? 'schaetzung' : 'aufwaende';
        this.$state.go(nextPage, {schadenfallId: this.schadenfallId});
    }

    public isFremdkostenReadonly() {
        //FIXME FS-706 temporary hack. Solve with separate view
        return (this.schaetzung &&
            !(this.schadenfallModelManager.isSchadenfallStatus(TSSchadenfallStatus.AUFTRAG_SCHAETZER) ||
                this.schadenfallModelManager.isSchadenfallStatus(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE)));
    }

    private getRequiredDocs(): number {
        let required = 1; //1: mandatory, 0: optional
        let fremdkosten = this.getModel();

        if (fremdkosten && fremdkosten.fremdkostenDatenFS && fremdkosten.fremdkostenDatenFS.leistungsart) {
            if (fremdkosten.fremdkostenDatenFS.leistungsart === TSLeistungsart.MATERIAL) {
                required = 0;
            }
        }
        if (this.schaetzung) {
            required = 0;
        }
        return required;
    }
}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/fremdkostenView/fremdkostenView.ts